import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useQueryKeys } from '../useQueryKeys'
import { getApiClient } from '../../stores'

export function useUpcomingInvoices() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ workspaceId }: { workspaceId: string }) => {
      return await getApiClient({ workspaceId }).getUpcomingInvoice({ id: workspaceId })
    },
    onSuccess: async (_, { workspaceId }) => {
      await queryClient.invalidateQueries({ queryKey: useQueryKeys().getUpcomingInvoice(workspaceId) })
    },
  })
}
